import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { IoClose } from "react-icons/io5";


const AddTrainingTypeModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="training-modal"
    >
      <div className="modal-container">
        {/* Header */}
        <div className="modal-header-custom">
          <h5>Add Training Type</h5>
          <IoClose className="close-icon" onClick={onHide} />
        </div>

        {/* Body */}
        <div className="modal-body-custom">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Control type="text" placeholder="" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>

            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Select>
                <option>Active</option>
                <option>Inactive</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </div>

        {/* Footer */}
        <div className="modal-footer-custom">
          <Button variant="light" className="cancel-btn" onClick={onHide}>
            Cancel
          </Button>
          <Button className="submit-btn">Add Training Type</Button>
        </div>
      </div>

      <style>
          {
               `
               
               /* Modal container */
.training-modal .modal-content {
  border-radius: 12px;
  border: none;
  overflow: hidden;
}

/* Header */
.modal-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.modal-header-custom h5 {
  font-weight: 600;
  margin: 0;
}

.close-icon {
  font-size: 22px;
  cursor: pointer;
  color: #6c757d;
}

/* Body */
.modal-body-custom {
  padding: 0 20px 20px 20px;
}

.modal-body-custom label {
  font-weight: 500;
  margin-bottom: 6px;
}

.modal-body-custom .form-control,
.modal-body-custom .form-select {
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
}

/* Footer */
.modal-footer-custom {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

/* Buttons */
.cancel-btn {
  background: #f1f3f5;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
}

.submit-btn {
  background: #f26522;
  border: none;
  padding: 8px 18px;
  border-radius: 8px;
}

.submit-btn:hover {
  background: #d9531e;
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .modal-header-custom,
  .modal-body-custom,
  .modal-footer-custom {
    padding: 15px;
  }

  .modal-footer-custom {
    flex-direction: column;
  }

  .cancel-btn,
  .submit-btn {
    width: 100%;
  }
}`
          }
      </style>
    </Modal>
  );
};

export default AddTrainingTypeModal;